import React from "react";
import { Box, Grid, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import Slider from "react-slick";
import { Business, Summarize, Plagiarism, TipsAndUpdates, TrendingUp } from "@mui/icons-material";


const WWOCardMain = styled(Box)(({theme}) => ({
  width: '25vw',
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
  
  [theme.breakpoints.down('lg')]: {
    width: '40vw',
  }
}))

const WWOCardTitle = styled(Typography)(({theme}) => ({
  color: '#55d6aa',
  fontSize: '1.5rem',
  fontWeight: '600',
  
  [theme.breakpoints.down('lg')]: {
    fontSize: '1.2rem',

  }
}))

const WWOCard = ({ Icon, Title, Description }) => {
  return (
    <WWOCardMain>
      <Box sx={{ width: '100%', height: '50%', display: 'flex', flexDirection: 'column', gap: 1 }} >
        <Icon sx={{ p: 1, fontSize: '1.8rem', color: '#ffdd24', bgcolor: '#242424', borderRadius: '50%' }} />
        <WWOCardTitle>{Title}</WWOCardTitle>
      </Box>
      <Box sx={{ height: '50%', display: 'flex', alignItems: 'start' }} >
        <Typography variant="body1" >{Description}</Typography>
      </Box>
    </WWOCardMain>
  );
};

function WhatWeOffer() {

  const services = [
    {
      icon: Business,
      title: "Company Profiles",
      description: "Gain in-depth visibility into any organization’s financials, leadership, strategies, and operations.",
    },
    {
      icon: Summarize,
      title: "Market Research Reports",
      description: "Access structured, data-backed insights featuring forecasts, opportunity mapping, CL-CP, PESTEL, Porter’s Five Forces, and investment feasibility.",
    },
    {
      icon: Plagiarism,
      title: "Industry & Domain Analysis",
      description: "Discover sector-wide trends, technological shifts, and inter-industry dynamics that shape the global economy.",
    },
    {
      icon: TipsAndUpdates,
      title: "Competitive Intelligence",
      description: "Benchmark against market leaders with detailed competitor analysis and strategic assessments.",
    },
    {
      icon: TrendingUp,
      title: "Recent Developments & Trends",
      description: "Stay informed on evolving regulations, disruptive innovations, and industry-defining news.",
    }
  ];

  return (
    <Box
      id="WhatWeOffer-section"
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: '#fff',
        py: 10,
      }}
    >
      <Typography fontWeight={600} align="center" gutterBottom sx={{ fontSize: { md: '2.1rem', xs: '1.5rem' } }} >
        What We Offer
      </Typography>
      <Typography align="center" paragraph sx={{ fontSize: { md: '1.1rem', xs: '0.9rem' }, textAlign: 'center', mx: '1rem', mb: 10 }} >
        We go beyond traditional market surveys by offering{" "}
        executive-level blueprints and actionable strategies that drive
        growth. Our expertise spans across:
      </Typography>

      {/* { !isMobile ? */}

      <Grid
      container
      justifyContent="center"
      alignItems="center"
      rowSpacing={2}
      columnSpacing={3}
        sx={{
          width: "90%",
        }}
      >
        {services.map((service) => (
          <WWOCard key={service} Icon={service.icon} Title={service.title} Description={service.description} />
        ))}
      </Grid>

    </Box>
  );
}

export default WhatWeOffer;
